import { render, staticRenderFns } from "./RCard.vue?vue&type=template&id=e90972c2&scoped=true"
import script from "./RCard.vue?vue&type=script&lang=js"
export * from "./RCard.vue?vue&type=script&lang=js"
import style0 from "./RCard.vue?vue&type=style&index=0&id=e90972c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90972c2",
  null
  
)

export default component.exports